module.exports = __webpack_public_path__ + "static/media/istant.fa782533.svg";